





























import { defineComponent, PropType, useRoute, computed } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { THUMBNAIL_300, THUMBNAIL_400 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { ECSchema } from '~/types/api';

export default defineComponent({
  components: { AppIcon, AppLink, AppImage },
  props: {
    shopInfo: {
      type: Object as PropType<ECSchema<'saleslocation.SalesLocation'>>,
      required: true,
    },
  },
  setup() {
    const route = useRoute();

    // ショップ一覧か
    const isShopList = computed(() => {
      return route.value.path === url('SHOP_LIST');
    });
    return { url, isShopList, THUMBNAIL_300, THUMBNAIL_400 };
  },
});
